<template>
<div>
  <p  class="text-primary tc-wd-word-label mr-2 sentence flex items-center justify-center">{{data}}</p> 
</div>
</template>

<script>

export default {
  components: {
    
  },
  props: {
    data: String
  }
}

</script>
